// extracted by mini-css-extract-plugin
export default {"container":"AssetsPage_container__W8Oij"};